import React, { Component } from "react";
import moment from "moment";
import { ToastContainer } from "react-toastr";
import { Link, withRouter } from "react-router-dom";
import axios from "../utils/axios";
import $ from "jquery";
import { reload } from "../utils/datatable";
import {
  APPROVE_STATUS_COLOR_CLASS,
  MONTH,
  ROLE,
  SEND_STATUS_COLOR_CLASS,
  URL_S005,
  URL_S006,
  URL_S009,
} from "../utils/constants";
import { getUserInfo } from "../utils/auth";

function datatable() {
  return $("#example2").DataTable({
    responsive: true,
    autoWidth: false,
    paging: true,
    lengthChange: true,
    searching: true,
    ordering: true,
    columns: [
      { width: "3%" },
      { width: "22%" },
      { width: "15%" },
      { width: "13%" },
      { width: "13%" },
      { width: "13%" },
      { width: "21%" },
    ],
    footerCallback: function (row, data, start, end, display) {
      var api = this.api();

      // Remove the formatting to get integer data for summation
      var intVal = function (i) {
        return typeof i === "string"
          ? i !== "-"
            ? i * 1
            : 0
          : typeof i === "number"
          ? i
          : 0;
      };

      for (let i = 2; i < 7; i++) {
        // Total over all pages
        let total = api
          .column(i)
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Update footer
        $(api.column(i).footer()).html(total);
      }
    },
  });
}

class S005 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      monthText: moment().format("MM-YYYY"),
      department_id: "",
      departments: [],
      timesheets: [{ test: 1 }],
    };
  }

  getDepartments = async () => {
    try {
      const response = await axios()
        .get(`/departments/actives`)
        .then((res) => {
          return res.data;
        });
      this.setState({ departments: response });
    } catch (err) {
      console.log(err);
    }
  };

  getDepartmentSummary = async (month) => {
    let path;
    const info = getUserInfo();
    if (this.props.location.pathname.slice(0, 10) === URL_S005) {
      if (info.userRole === ROLE.admin) {
        path = `/timesheets/departments/month/${month}`;
      } else {
        path = `/timesheets/departments/approve-by/${info.userId}/month/${month}`;
      }
    } else {
      path = `/timesheets/departments/month/${month}`;
    }
    return await axios()
      .get(path)
      .then((res) => {
        console.log(res);
        return res.data;
      });
  };

  componentDidMount = async () => {
    let month, year;
    if (this.props.location.state) {
      month = this.props.location.state.month.slice(0, 2);
      year = this.props.location.state.month.slice(3, 7);
      this.setState({ monthText: this.props.location.state.month });
    } else {
      month = this.state.monthText.slice(0, 2);
      year = this.state.monthText.slice(3, 7);
    }
    let timesheets = await this.getDepartmentSummary(year + month);
    timesheets.sort(
      (a, b) => -b.department_code.localeCompare(a.department_code)
    );
    this.setState({ timesheets });
    datatable();
  };

  _handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };

  _handleMonthChange = (event) => {
    let monthText;
    if (event.target.id === "month") {
      monthText = event.target.value + this.state.monthText.slice(2, 7);
    } else {
      monthText = this.state.monthText.slice(0, 3) + event.target.value;
    }
    this.setState({ monthText });
  };

  _handleSearch = async (e) => {
    e.preventDefault();
    const month = this.state.monthText.slice(0, 2);
    const year = this.state.monthText.slice(3, 7);
    reload(this.props.history, this.props.location.pathname, {
      month: `${month}-${year}`,
    });
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => (this.container = ref)}
          className="toast-top-right"
        />
        {/* Main content */}
        <section className="content m-2">
          <div className="row mx-0">
            <div className="col">
              <div className="card">
                <div className="card-header">
                  <form className="d-flex flex-row mx-0">
                    <div className="input-group col-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="far fa-calendar-alt" />
                        </span>
                      </div>
                      <select
                        type="text"
                        className="form-control"
                        id="month"
                        value={this.state.monthText.slice(0, 2)}
                        onChange={this._handleMonthChange}
                      >
                        {MONTH.map((item, index) => {
                          let value;
                          if (index + 1 < 10) {
                            value = "0" + (+index + 1);
                          } else {
                            value = index + 1;
                          }
                          return (
                            <option key={index} value={value}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                      <select
                        type="text"
                        className="form-control"
                        id="year"
                        value={this.state.monthText.slice(3, 7)}
                        onChange={this._handleMonthChange}
                      >
                        <option key="3" value={+moment().format("YYYY") - 1}>
                          {+moment().format("YYYY") - 1}
                        </option>
                        <option key="2" value={+moment().format("YYYY")}>
                          {+moment().format("YYYY")}
                        </option>
                        <option key="1" value={+moment().format("YYYY") + 1}>
                          {+moment().format("YYYY") + 1}
                        </option>
                      </select>
                    </div>
                    <div className="input-group-append col-1">
                      <button
                        type="submit"
                        className="btn btn-outline-primary"
                        onClick={this._handleSearch}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                    {/* /.input group */}
                  </form>
                  {/* /.form group */}
                </div>
                <div className="card-body">
                  <table
                    id="example2"
                    className="table table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Department</th>
                        <th className={APPROVE_STATUS_COLOR_CLASS.approved}>
                          Approved (Items)
                        </th>
                        <th className={APPROVE_STATUS_COLOR_CLASS.rejected}>
                          Rejected (Items)
                        </th>
                        <th className={APPROVE_STATUS_COLOR_CLASS.pending}>
                          Pending (Items)
                        </th>
                        <th>Total (Items)</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {this.state.timesheets.length > 0 ? (
                      <>
                        <tbody>
                          {this.state.timesheets.map((item, index) => {
                            const month = this.state.monthText.slice(0, 2);
                            const year = this.state.monthText.slice(3, 7);
                            return (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>{item.department_name}</td>
                                <td
                                  className={
                                    APPROVE_STATUS_COLOR_CLASS.approved
                                  }
                                >
                                  {+item.approved || "-"}
                                </td>
                                <td
                                  className={
                                    APPROVE_STATUS_COLOR_CLASS.rejected
                                  }
                                >
                                  {+item.rejected || "-"}
                                </td>
                                <td
                                  className={APPROVE_STATUS_COLOR_CLASS.pending}
                                >
                                  {+item.pending || "-"}
                                </td>
                                <td>{+item.total || "-"}</td>
                                <td>
                                  <Link
                                    to={{
                                      pathname:
                                        (this.props.location.pathname.slice(
                                          0,
                                          10
                                        ) === URL_S005
                                          ? URL_S006
                                          : URL_S009) +
                                        `/${item.department_id}`,
                                      state: { month: `${month}-${year}` },
                                    }}
                                  >
                                    <button className="btn btn-sm btn-info mr-3">
                                      View
                                    </button>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="2" style={{ textAlign: "right" }}>
                              Total:
                            </th>
                            <th
                              className={APPROVE_STATUS_COLOR_CLASS.approved}
                            ></th>
                            <th
                              className={APPROVE_STATUS_COLOR_CLASS.rejected}
                            ></th>
                            <th
                              className={APPROVE_STATUS_COLOR_CLASS.pending}
                            ></th>
                            <th></th>
                            <th></th>
                          </tr>
                        </tfoot>
                      </>
                    ) : null}
                  </table>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </section>
      </div>
    );
  }
}

export default withRouter(S005);
